<!--
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-01-15 14:04:13
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-09-28 16:45:59
 * @FilePath: \crm-product\found\views\cps\views\execute\details_of_counterfeit_goods\details_of_counterfeit_goods.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<script>
import TablePage from '@/found/components/table_page';
import request from '@/found/utils/request';

export default {
  name: 'modules',
  extends: TablePage,
  data() {
    return {
      requestType: 'GET',
      requestUrl: '/cps-mobile/h5/fleeingGoods/detail/findByConditions',
      params: {},
      formConfig: {},
      modalConfig: {},
      searchFormData: {},
      formData: {},
      nowDate: null,
    };
  },
  async created() {
    const scanDateStart = this.formatTime(new Date().getTime(), 'Y-M-D');
    const scanDateEnd = this.formatTime(new Date().getTime(), 'Y-M-D');
    this.searchFormData = {
      ...this.searchFormData,
      scanDateStart,
      scanDateEnd,
    };
    this.nowDate = new Date().getTime();
    this.params.listId = this.nowDate;
    await this.getConfigList('details_of_counterfeit_goods_list');
    this.formData = {
      ...this.formData,
      scanDateStart,
      scanDateEnd,
    };
  },
  methods: {
    beforeButtonClick({ val }) {
      if (val.code === 'export') {
        val.queryUrl = `/cps-mobile/h5/fleeingGoods/detail/findByConditions?listId=${this.nowDate}`;
      }
      return true;
    },
    // 设置规则
    formatTime(timestamp, format) {
      const formatArr = ['Y', 'M', 'D', 'h', 'm', 's'];
      let returnArr = [];
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const hour = date.getHours();
      const minute = date.getMinutes();
      const second = date.getSeconds();
      returnArr.push(year, month, day, hour, minute, second);
      returnArr = returnArr.map((a) => {
        let n = a;
        n = n.toString();
        return n[1] ? n : `0${n}`;
      });
      let aaa = format;
      console.log(aaa);
      for (const i in returnArr) {
        if (i) {
          // console.log(returnArr[i]);
          console.log(formatArr[i]);
          aaa = aaa.replace(formatArr[i], returnArr[i]);
          console.log(aaa);
        }
      }
      return aaa;
    },
  },
};
</script>
